module.exports = __webpack_public_path__ + "img/cns_email_ios12.6e9de0dd.png";